import React from 'react';
import { ChevronRight } from 'lucide-react';

/** Цепочка шагов со стрелками — как в полной истории матча Секи. */
export function MatchChronicleChain({ steps }) {
  if (!Array.isArray(steps) || steps.length === 0) return null;
  return (
    <div className="mt-1.5 flex flex-wrap items-center gap-x-0.5 gap-y-1 text-[10px] leading-snug">
      {steps.map((lineText, i) => (
        <React.Fragment key={`chronicle-chain-${i}`}>
          {i > 0 ? (
            <ChevronRight className="mx-0.5 h-3.5 w-3.5 shrink-0 text-amber-500/70" aria-hidden />
          ) : null}
          <span className="max-w-full rounded-md border border-white/10 bg-black/35 px-1.5 py-0.5 text-amber-100/95">
            {lineText}
          </span>
        </React.Fragment>
      ))}
    </div>
  );
}

export function MatchChronicleVertical({ steps }) {
  if (!Array.isArray(steps) || steps.length === 0) return null;
  return (
    <ol className="mt-1.5 space-y-1.5 border-l border-amber-500/25 pl-2.5">
      {steps.map((line, i) => (
        <li key={`chronicle-v-${i}`} className="relative text-[10px] leading-snug text-amber-100/90">
          <span className="absolute -left-2.5 top-0.5 font-mono text-[9px] text-amber-400">{i + 1}.</span>
          {line}
        </li>
      ))}
    </ol>
  );
}
